import { getWrestlerName, getWrestlerNameUpper, wrestlerMatchesSearch, sortWrestlersByName } from './wrestlerUtils';
import React, { useState } from 'react';
import placeholder from '../assets/placeholder.png';
import placeholderTitle from '../assets/Placeholder_Title.png';
import background from '../assets/Background_Test.jpg';
import { TITLES_DATABASE, TITLE_CATEGORIES } from './titlesDatabase';
import SuperstarPicker from './SuperstarPicker';

import logoRaw from '../assets/brands/logos/RAW25_LOGO.png';
import logoSmackDown from '../assets/brands/logos/SMACKDOWN25_LOGO.png';
import logoNXT from '../assets/brands/logos/NXT_LOGO.png';
import logoNXT20 from '../assets/brands/logos/NXT20_LOGO.png';
import logoWCW from '../assets/brands/logos/WCW_LOGO.png';
import logoECW from '../assets/brands/logos/ECW_LOGO.png';
import logoNXTMutiny from '../assets/brands/logos/NXTMUTINY_LOGO.png';
import bgRaw from '../assets/brands/backgrounds/RAW25_BACKGROUND.png';
import bgSmackDown from '../assets/brands/backgrounds/SMACKDOWN25_BACKGROUND.png';
import bgNXT from '../assets/brands/backgrounds/NXT_BACKGROUND.png';
import bgNXT20 from '../assets/brands/backgrounds/NXT20_BACKGROUND.png';
import bgWCW from '../assets/brands/backgrounds/WCW_BACKGROUND.png';
import bgECW from '../assets/brands/backgrounds/ECW_BACKGROUND.png';
import bgNXTMutiny from '../assets/brands/backgrounds/NXTMUTINY_BACKGROUND.png';


// Dynamic wrestler render loader
const getWrestlerRender = (w) => {
  if (!w) return null;
  if (w.customRender) return w.customRender;
  if (w.wrestler_id) return process.env.PUBLIC_URL + '/wrestlers/' + w.wrestler_id + '-render.png';
  return null;
};

// Dynamic title render loader
const getTitleRender = (titleId) => {
  if (!titleId) return null;
  return process.env.PUBLIC_URL + '/titles/' + titleId + '-render.png';
};

const BRAND_LOGOS = { 'Raw': logoRaw, 'SmackDown': logoSmackDown, 'NXT': logoNXT, 'NXT 2.0': logoNXT20, 'WCW': logoWCW, 'ECW': logoECW, 'NXT Mutiny': logoNXTMutiny };
const BRAND_BGS = { 'Raw': bgRaw, 'SmackDown': bgSmackDown, 'NXT': bgNXT, 'NXT 2.0': bgNXT20, 'WCW': bgWCW, 'ECW': bgECW, 'NXT Mutiny': bgNXTMutiny };
const BRAND_COLORS = { 'Raw': '#c0392b', 'SmackDown': '#1a6bb5', 'NXT': '#a8a9ad', 'NXT 2.0': '#e91e8c', 'ECW': '#7b1fa2', 'WCW': '#e65100', 'NXT Mutiny': '#424242' };

const DEFAULT_SLOTS = {
  default: {
    male: [{ key: 'male-world', label: 'World Title', gender: 'male', isTagTeam: false }, { key: 'male-minor', label: 'Minor Title', gender: 'male', isTagTeam: false }],
    female: [{ key: 'female-world', label: 'World Title', gender: 'female', isTagTeam: false }, { key: 'female-minor', label: 'Minor Title', gender: 'female', isTagTeam: false }],
    tagteam: [{ key: 'tagteam-male', label: 'Male TagTeam', gender: 'male', isTagTeam: true }, { key: 'tagteam-female', label: 'Female TagTeam', gender: 'female', isTagTeam: true }],
  },
  ECW: {
    male: [{ key: 'male-world', label: 'World Title', gender: 'male', isTagTeam: false }, { key: 'male-minor', label: 'Minor Title', gender: 'male', isTagTeam: false }],
    female: [],
    tagteam: [{ key: 'tagteam-male', label: 'Male TagTeam', gender: 'male', isTagTeam: true }],
  },
  'NXT 2.0': {
    male: [{ key: 'male-world', label: 'World Title', gender: 'male', isTagTeam: false }, { key: 'male-minor', label: 'Minor Title', gender: 'male', isTagTeam: false }],
    female: [{ key: 'female-world', label: 'World Title', gender: 'female', isTagTeam: false }],
    tagteam: [{ key: 'tagteam-male', label: 'Male TagTeam', gender: 'male', isTagTeam: true }, { key: 'tagteam-female', label: 'Female TagTeam', gender: 'female', isTagTeam: true }],
  },
  WCW: {
    male: [{ key: 'male-world', label: 'World Title', gender: 'male', isTagTeam: false }, { key: 'male-minor', label: 'Minor Title', gender: 'male', isTagTeam: false }],
    female: [{ key: 'female-world', label: 'World Title', gender: 'female', isTagTeam: false }],
    tagteam: [{ key: 'tagteam-male', label: 'Male TagTeam', gender: 'male', isTagTeam: true }, { key: 'tagteam-female', label: 'Female TagTeam', gender: 'female', isTagTeam: true }],
  },
  'NXT Mutiny': {
    male: [{ key: 'male-world', label: 'World Title', gender: 'male', isTagTeam: false }, { key: 'male-minor', label: 'Minor Title', gender: 'male', isTagTeam: false }],
    female: [{ key: 'female-world', label: 'World Title', gender: 'female', isTagTeam: false }],
    tagteam: [{ key: 'tagteam-male', label: 'Male TagTeam', gender: 'male', isTagTeam: true }, { key: 'tagteam-female', label: 'Female TagTeam', gender: 'female', isTagTeam: true }],
  },
};

// Default title assignments per brand
const BRAND_DEFAULT_TITLES = {
  'Raw': {
    'male-world':    { id: 'wwe-world-heavy', name: 'WWE World Heavyweight Championship' },
    'male-minor':    { id: 'wwe-ic',          name: 'WWE Intercontinental Championship' },
    'tagteam-male':  { id: 'wwe-world-tag',   name: 'WWE World Tag Team Championship' },
    'female-world':  { id: 'wwe-womens-world',name: "WWE Women's World Championship" },
    'female-minor':  { id: 'wwe-womens-ic',   name: "WWE Women's Intercontinental Championship" },
    'tagteam-female':{ id: 'wwe-womens-tag',  name: "WWE Women's Tag Team Championship" },
  },
  'SmackDown': {
    'male-world':    { id: 'wwe-undisputed',  name: 'WWE Undisputed Championship' },
    'male-minor':    { id: 'wwe-us',          name: 'WWE United States Championship' },
    'tagteam-male':  { id: 'wwe-tag',         name: 'WWE Tag Team Championship' },
    'female-world':  { id: 'wwe-womens',      name: "WWE Women's Championship" },
    'female-minor':  { id: 'wwe-womens-us',   name: "WWE Women's United States Championship" },
    'tagteam-female':{ id: 'wwe-womens-tag',  name: "WWE Women's Tag Team Championship" },
  },
  'NXT': {
    'male-world':    { id: 'nxt-champ',       name: 'NXT Championship' },
    'male-minor':    { id: 'nxt-na',          name: 'NXT North American Championship' },
    'tagteam-male':  { id: 'nxt-tag',         name: 'NXT Tag Team Championship' },
    'female-world':  { id: 'nxt-womens',      name: "NXT Women's Championship" },
    'female-minor':  { id: 'nxt-womens-na',   name: "NXT Women's North American Championship" },
    'tagteam-female':{ id: 'wwe-womens-tag',  name: "WWE Women's Tag Team Championship" },
  },
  'NXT 2.0': {
    'male-world':    { id: 'wwe-c-33',        name: 'NXT 2.0 Championship' },
    'male-minor':    { id: 'nxt-na',          name: 'NXT North American Championship' },
    'tagteam-male':  { id: 'nxt-tag',         name: 'NXT Tag Team Championship' },
    'female-world':  { id: 'wwe-c-37',        name: "NXT 2.0 Women's Championship" },
    'tagteam-female':{ id: 'wwe-c-40',        name: "NXT 2.0 Women's Tag Team Championship" },
  },
  'ECW': {
    'male-world':    { id: 'ecw-3',           name: 'ECW Championship' },
    'male-minor':    { id: 'ecw-4',           name: 'ECW Television Championship' },
    'tagteam-male':  { id: 'ecw-5',           name: 'ECW Tag Team Championship' },
  },
  'WCW': {
    'male-world':    { id: 'wcw-1',           name: 'WCW World Heavyweight Championship' },
    'male-minor':    { id: 'wcw-4',           name: 'WCW United States Championship' },
    'tagteam-male':  { id: 'wcw-8',           name: 'WCW Tag Team Championship' },
    'female-world':  { id: 'wcw-9',           name: "WCW Women's Championship" },
    'tagteam-female':{ id: 'wwe-womens-tag',  name: "WWE Women's Tag Team Championship" },
  },
  'NXT Mutiny': {
    'male-world':    { id: 'misc-5',          name: 'NXT Mutiny Championship' },
    'male-minor':    { id: 'misc-10',         name: 'NXT Mutiny Minor Championship' },
    'tagteam-male':  { id: 'misc-7',          name: 'NXT Mutiny Tag Team Championship' },
    'female-world':  { id: 'misc-8',          name: "NXT Mutiny Women's Championship" },
    'tagteam-female':{ id: 'misc-9',          name: "NXT Mutiny Women's Tag Team Championship" },
  },
};

const css = `
  * { box-sizing: border-box; }
  html { font-size: 133%; }
  .title-card { transition: background 0.2s, border-color 0.2s, transform 0.2s; cursor: pointer; }
  .title-card:hover { outline: 1.5px solid rgba(212,175,55,0.6) !important; transform: translateY(-2px); }
  .btn-wwe:hover { background: rgba(255,255,255,0.1) !important; border-color: rgba(255,255,255,0.6) !important; color: #fff !important; }
  .btn-gold:hover { background: rgba(212,175,55,0.15) !important; border-color: #d4af37 !important; color: #d4af37 !important; }
  .btn-red:hover { background: rgba(231,76,60,0.15) !important; border-color: #e74c3c !important; color: #e74c3c !important; }
  .tab-btn { transition: background 0.15s, border-color 0.15s, color 0.15s; cursor: pointer; }
  .tab-btn.active { border-bottom: 2px solid #d4af37 !important; color: #d4af37 !important; }
  .tab-btn:not(.active):hover { color: rgba(212,175,55,0.6) !important; }
  .picker-row { transition: background 0.1s; cursor: pointer; }
  .picker-row:hover { background: rgba(212,175,55,0.08) !important; }
  .title-row { transition: background 0.1s; cursor: pointer; }
  .title-row:hover { background: rgba(212,175,55,0.06) !important; }
  .title-row.selected { background: rgba(212,175,55,0.12) !important; }
  ::-webkit-scrollbar { width: 4px; }
  ::-webkit-scrollbar-thumb { background: rgba(212,175,55,0.2); border-radius: 2px; }
  select option { background: #1a1a1a; color: #fff; }
`;

const S = {
  panel: { background: 'rgba(8,6,0,0.92)', border: '1px solid rgba(212,175,55,0.2)', borderRadius: '12px', boxShadow: '0 20px 80px rgba(0,0,0,0.9)' },
  goldTitle: { fontFamily: "'Anton', sans-serif", letterSpacing: '3px', color: '#d4af37', textShadow: '0 0 20px rgba(212,175,55,0.4)' },
  btn: { fontFamily: "'Monda', sans-serif", letterSpacing: '1.5px', fontSize: '0.55rem', background: 'transparent', border: '1px solid rgba(255,255,255,0.25)', color: 'rgba(255,255,255,0.6)', padding: '6px 14px', borderRadius: '4px', cursor: 'pointer', transition: 'background 0.18s, border-color 0.18s, color 0.18s' },
  mono: { fontFamily: "'Monda', sans-serif" },
  anton: { fontFamily: "'Anton', sans-serif" },
  input: { background: 'rgba(212,175,55,0.06)', border: '1px solid rgba(212,175,55,0.2)', borderRadius: '4px', padding: '7px 12px', color: '#fff', fontSize: '0.6rem', fontFamily: "'Monda',sans-serif", outline: 'none', width: '100%' },
};

// ── Title Picker (grille de cards) ──────────────────────────────────
const TitlePicker = ({ slot, customTitles, onClose, onSaveTitle, onEditCustomTitle, onDeleteCustomTitle }) => {
  const [titleSearch, setTitleSearch] = useState('');
  const [titleCategory, setTitleCategory] = useState('ALL');
  const [selectedTitle, setSelectedTitle] = useState(slot.titleOverride || null);
  const [showAddCustom, setShowAddCustom] = useState(false);
  const [editingCustom, setEditingCustom] = useState(null);
  const [customForm, setCustomForm] = useState({ name: '', render: null, gender: slot.gender || 'male', isTagTeam: slot.isTagTeam || false });

  const allTitles = [
    ...TITLES_DATABASE.filter(t => {
      if (titleCategory !== 'ALL' && titleCategory !== 'CUSTOM' && t.category !== titleCategory) return false;
      if (titleCategory === 'CUSTOM') return false;
      if (titleSearch && !t.name.toLowerCase().includes(titleSearch.toLowerCase())) return false;
      return true;
    }),
    ...(customTitles || []).filter(t => {
      if (titleCategory !== 'ALL' && titleCategory !== 'CUSTOM') return false;
      if (titleSearch && !t.name.toLowerCase().includes(titleSearch.toLowerCase())) return false;
      return true;
    }).map(t => ({ ...t, isCustom: true })),
  ];

  const handleTitleUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = ev => setCustomForm(p => ({ ...p, render: ev.target.result }));
    reader.readAsDataURL(file);
  };

  const handleSaveCustomTitle = () => {
    if (!customForm.name.trim()) return;
    const t = { ...customForm, id: editingCustom?.id || ('custom-' + Date.now()), isCustom: true };
    onEditCustomTitle(t, !!editingCustom);
    setShowAddCustom(false); setEditingCustom(null);
    setCustomForm({ name: '', render: null, gender: slot.gender || 'male', isTagTeam: slot.isTagTeam || false });
  };

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 1100, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.88)', backdropFilter: 'blur(6px)' }}
      onClick={onClose}>
      <div style={{ ...S.panel, width: 'min(95vw, 1100px)', height: '85vh', display: 'flex', flexDirection: 'column' }}
        onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div style={{ padding: '16px 24px 12px', borderBottom: '1px solid rgba(212,175,55,0.15)', display: 'flex', alignItems: 'center', gap: '12px', flexShrink: 0 }}>
          <div style={{ ...S.goldTitle, fontSize: '0.85rem' }}>SELECT TITLE</div>
          <div style={{ ...S.mono, fontSize: '0.4rem', color: 'rgba(212,175,55,0.4)', letterSpacing: '1px' }}>
            {slot.isTagTeam ? 'TAG TEAM · ' : ''}{slot.gender?.toUpperCase()}
          </div>
          <button onClick={onClose} style={{ marginLeft: 'auto', background: 'none', border: '1px solid rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.3)', cursor: 'pointer', borderRadius: '4px', width: '28px', height: '28px' }}>✕</button>
        </div>

        {/* Filters */}
        <div style={{ padding: '10px 24px', borderBottom: '1px solid rgba(212,175,55,0.08)', display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center', flexShrink: 0 }}>
          {['ALL', ...TITLE_CATEGORIES, 'CUSTOM'].map(cat => (
            <button key={cat} onClick={() => setTitleCategory(cat)}
              style={{ ...S.mono, fontSize: '0.42rem', letterSpacing: '1px', background: titleCategory === cat ? 'rgba(212,175,55,0.15)' : 'transparent', border: `1px solid ${titleCategory === cat ? 'rgba(212,175,55,0.6)' : 'rgba(212,175,55,0.15)'}`, color: titleCategory === cat ? '#d4af37' : 'rgba(212,175,55,0.4)', padding: '4px 12px', borderRadius: '3px', cursor: 'pointer' }}>
              {cat}
            </button>
          ))}
          <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
            <input style={{ ...S.input, width: '180px' }} placeholder="Search..." value={titleSearch} onChange={e => setTitleSearch(e.target.value)} />
            <button onClick={() => { setShowAddCustom(true); setEditingCustom(null); setCustomForm({ name: '', render: null, gender: slot.gender || 'male', isTagTeam: slot.isTagTeam || false }); }}
              style={{ ...S.btn, borderColor: 'rgba(212,175,55,0.4)', color: 'rgba(212,175,55,0.7)', whiteSpace: 'nowrap', fontSize: '0.44rem' }}>+ CUSTOM</button>
          </div>
        </div>

        {/* Custom form */}
        {showAddCustom && (
          <div style={{ padding: '12px 24px', borderBottom: '1px solid rgba(212,175,55,0.08)', flexShrink: 0 }}>
            <div style={{ ...S.panel, padding: '12px 14px' }}>
              <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                <div onClick={() => document.getElementById('customTitleUpload').click()}
                  style={{ width: '120px', height: '70px', border: '1px dashed rgba(212,175,55,0.3)', borderRadius: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', overflow: 'hidden', background: 'rgba(212,175,55,0.04)', flexShrink: 0 }}>
                  {customForm.render ? <img src={customForm.render} alt="" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                    : <span style={{ ...S.mono, fontSize: '0.38rem', color: 'rgba(212,175,55,0.3)', textAlign: 'center' }}>PNG 1024×512</span>}
                </div>
                <input id="customTitleUpload" type="file" accept="image/png" style={{ display: 'none' }} onChange={handleTitleUpload} />
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <input style={S.input} placeholder="Title name *" value={customForm.name} onChange={e => setCustomForm(p => ({ ...p, name: e.target.value }))} />
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <select style={{ ...S.input, flex: 1 }} value={customForm.gender} onChange={e => setCustomForm(p => ({ ...p, gender: e.target.value }))}>
                      <option value="male">Male</option><option value="female">Female</option><option value="all">Mixed</option>
                    </select>
                    <select style={{ ...S.input, flex: 1 }} value={customForm.isTagTeam ? 'tag' : 'single'} onChange={e => setCustomForm(p => ({ ...p, isTagTeam: e.target.value === 'tag' }))}>
                      <option value="single">Singles</option><option value="tag">Tag Team</option>
                    </select>
                  </div>
                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '6px', marginTop: '8px' }}>
                <button style={{ ...S.btn, fontSize: '0.44rem' }} onClick={() => setShowAddCustom(false)}>CANCEL</button>
                <button style={{ ...S.btn, borderColor: customForm.name ? 'rgba(212,175,55,0.5)' : 'rgba(212,175,55,0.15)', color: customForm.name ? '#d4af37' : 'rgba(212,175,55,0.25)', fontSize: '0.44rem' }}
                  onClick={handleSaveCustomTitle}>{editingCustom ? 'UPDATE' : 'ADD'}</button>
              </div>
            </div>
          </div>
        )}

        {/* Title grid */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '16px 24px', display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '12px', alignContent: 'flex-start' }}>
          {allTitles.map(t => {
            const isSel = selectedTitle?.id === t.id;
            const render = t.render || getTitleRender(t.id) || placeholderTitle;
            return (
              <div key={t.id} onClick={() => setSelectedTitle(isSel ? null : t)}
                style={{ background: isSel ? 'rgba(212,175,55,0.12)' : 'rgba(255,255,255,0.03)', border: '1px solid ' + (isSel ? 'rgba(212,175,55,0.6)' : 'rgba(255,255,255,0.08)'), borderRadius: '8px', overflow: 'hidden', cursor: 'pointer', display: 'flex', flexDirection: 'column', transition: 'all 0.12s', position: 'relative', minHeight: '160px' }}
                onMouseEnter={e => { if (!isSel) e.currentTarget.style.borderColor = 'rgba(212,175,55,0.3)'; }}
                onMouseLeave={e => { if (!isSel) e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)'; }}>
                {isSel && <div style={{ position: 'absolute', top: '6px', right: '6px', color: '#d4af37', fontSize: '0.8rem', zIndex: 1 }}>✓</div>}
                {t.isCustom && <div style={{ position: 'absolute', top: '6px', left: '6px', ...S.mono, fontSize: '0.33rem', color: '#d4af37', background: 'rgba(212,175,55,0.15)', border: '1px solid rgba(212,175,55,0.3)', borderRadius: '2px', padding: '1px 4px', zIndex: 1 }}>CUSTOM</div>}
                {/* Belt render — format paysage 1024x512 */}
                <div style={{ width: '100%', height: '110px', background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '12px 16px' }}>
                  <img src={render} alt="" style={{ width: '100%', maxHeight: '86px', objectFit: 'contain', filter: 'drop-shadow(0 0 8px rgba(212,175,55,0.4))' }} onError={e => { e.target.src = placeholderTitle; }} />
                </div>
                {/* Name + actions */}
                <div style={{ padding: '8px 10px 10px', borderTop: '1px solid rgba(212,175,55,0.08)' }}>
                  <div style={{ ...S.mono, fontSize: '0.42rem', color: isSel ? '#d4af37' : '#fff', lineHeight: 1.3, marginBottom: '3px', textAlign: 'center' }}>{t.name}</div>
                  <div style={{ ...S.mono, fontSize: '0.34rem', color: 'rgba(255,255,255,0.25)', textAlign: 'center' }}>{t.category}</div>
                  {t.isCustom && (
                    <div style={{ display: 'flex', gap: '4px', marginTop: '6px', justifyContent: 'center' }}>
                      <button style={{ ...S.btn, fontSize: '0.36rem', padding: '2px 8px' }}
                        onClick={e => { e.stopPropagation(); setEditingCustom(t); setCustomForm({ name: t.name, render: t.render, gender: t.gender, isTagTeam: t.isTagTeam }); setShowAddCustom(true); }}>✏</button>
                      <button style={{ ...S.btn, fontSize: '0.36rem', padding: '2px 8px', borderColor: 'rgba(231,76,60,0.35)', color: 'rgba(231,76,60,0.6)' }}
                        onClick={e => { e.stopPropagation(); onDeleteCustomTitle(t.id); if (selectedTitle?.id === t.id) setSelectedTitle(null); }}>✕</button>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
          {allTitles.length === 0 && <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: '40px', ...S.mono, fontSize: '0.5rem', color: 'rgba(255,255,255,0.2)' }}>No titles found</div>}
        </div>

        {/* Footer */}
        <div style={{ padding: '12px 24px', borderTop: '1px solid rgba(212,175,55,0.15)', display: 'flex', justifyContent: 'space-between', flexShrink: 0 }}>
          <button style={S.btn} onClick={onClose}>CANCEL</button>
          <button style={{ ...S.btn, borderColor: 'rgba(212,175,55,0.5)', color: '#d4af37' }} onClick={() => { onSaveTitle(selectedTitle); onClose(); }}>CONFIRM</button>
        </div>
      </div>
    </div>
  );
};

// ── Slot Picker — now just triggers ChampionPicker or TitlePicker ────
const SlotPicker = ({ slot, champion, customTitles, roster, onClose, onSaveChampion, onSaveTitle, onEditCustomTitle, onDeleteCustomTitle }) => {
  const [mode, setMode] = useState('champion'); // 'champion' | 'title'
  const [picked1, setPicked1] = useState(champion?.[0] || null);
  const [picked2, setPicked2] = useState(champion?.[1] || null);

  const defaultGender = slot.gender === 'female' ? 'FEMALE' : slot.gender === 'male' ? 'MALE' : 'ALL';
  const selectedIds = [picked1, picked2].filter(Boolean).map(p => p.wrestler_id);
  const canConfirm = picked1 && (!slot.isTagTeam || picked2);

  const handleSelectChampion = (w) => {
    if (!slot.isTagTeam) {
      setPicked1(p => p?.wrestler_id === w.wrestler_id ? null : w);
      return;
    }
    if (picked1?.wrestler_id === w.wrestler_id) { setPicked1(null); return; }
    if (picked2?.wrestler_id === w.wrestler_id) { setPicked2(null); return; }
    if (!picked1) { setPicked1(w); return; }
    if (!picked2) { setPicked2(w); return; }
    setPicked1(w); setPicked2(null);
  };

  const handleConfirmChampion = () => {
    if (slot.isTagTeam) onSaveChampion(picked1 && picked2 ? [picked1, picked2] : null);
    else onSaveChampion(picked1 ? [picked1] : null);
    onClose();
  };

  if (mode === 'title') {
    return (
      <TitlePicker
        slot={slot}
        customTitles={customTitles}
        onClose={() => setMode('champion')}
        onSaveTitle={(t) => { onSaveTitle(t); onClose(); }}
        onEditCustomTitle={onEditCustomTitle}
        onDeleteCustomTitle={onDeleteCustomTitle}
      />
    );
  }

  // Champion picker mode — SuperstarPicker avec confirm en bas
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 1100, background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(2px)' }}>
      <SuperstarPicker
          roster={roster}
          alreadyPicked={[]}
          onSelect={handleSelectChampion}
          onClose={onClose}
          filterActive={true}
          autoClose={false}
          showSynergy={false}
          defaultGender={defaultGender}
          selectedIds={selectedIds}
          showConfirm={true}
          onConfirm={handleConfirmChampion}
          confirmDisabled={!canConfirm}
          title={slot.isTagTeam ? `SELECT PARTNERS (${selectedIds.length}/2)` : 'SELECT CHAMPION'}
          rivalries={[]}
          onChangeTitle={() => setMode('title')}
        />
    </div>
  );
};

// ── Title Card ──────────────────────────────────────────────────────
const TitleCard = ({ slot, champion, disabled, onClick }) => {
  const hasChampion = champion && champion.length > 0;
  const isTagTeam = slot.isTagTeam;
  const titleRender = (slot.titleOverride && slot.titleOverride.render) || (slot.titleOverride && getTitleRender(slot.titleOverride.id)) || placeholderTitle;
  const titleLabel = slot.titleOverride?.name || slot.label;

  return (
    <div className={disabled ? '' : 'title-card'}
      onClick={disabled ? undefined : onClick}
      style={{ borderRadius: '10px', overflow: 'hidden', border: `1px solid ${disabled ? 'rgba(255,255,255,0.04)' : hasChampion ? 'rgba(212,175,55,0.45)' : 'rgba(212,175,55,0.15)'}`, position: 'relative', cursor: disabled ? 'not-allowed' : 'pointer', background: disabled ? 'rgba(255,255,255,0.01)' : hasChampion ? 'rgba(20,14,0,0.95)' : 'rgba(10,8,0,0.85)', outline: '1px solid transparent', opacity: disabled ? 0.3 : 1, display: 'flex', flexDirection: 'column' }}>

      {hasChampion && !disabled && <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at top, rgba(212,175,55,0.1) 0%, transparent 65%)', zIndex: 0 }} />}
      {slot.titleOverride?.isCustom && !disabled && (
        <div style={{ position: 'absolute', top: '6px', left: '6px', zIndex: 4, fontFamily: "'Monda',sans-serif", fontSize: '0.32rem', color: '#d4af37', background: 'rgba(212,175,55,0.15)', border: '1px solid rgba(212,175,55,0.3)', borderRadius: '2px', padding: '1px 4px' }}>CUSTOM</div>
      )}

      <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', overflow: 'hidden' }}>
        {/* Belt on top */}
        <div style={{ padding: '10px 8px 4px', display: 'flex', justifyContent: 'center', width: '100%' }}>
          <img loading="lazy" src={titleRender} alt=""
            style={{ width: isTagTeam ? '70%' : '95%', maxWidth: isTagTeam ? '140px' : '200px', objectFit: 'contain', filter: `drop-shadow(0 4px 16px rgba(212,175,55,${hasChampion ? '0.55' : '0.2'}))`, opacity: disabled ? 0.3 : 1 }} />
        </div>
        {/* Superstar(s) below */}
        {!disabled && (
          isTagTeam ? (
            <div style={{ display: 'flex', width: '100%', alignItems: 'flex-end', justifyContent: 'center' }}>
              {[0, 1].map(idx => (
                <div key={idx} style={{ flex: 1, display: 'flex', justifyContent: 'center', overflow: 'hidden' }}>
                  <img loading="lazy" src={getWrestlerRender(champion?.[idx]) || placeholder} alt=""
                    style={{ height: '260px', objectFit: 'contain', objectPosition: 'top', filter: hasChampion ? 'drop-shadow(0 4px 14px rgba(212,175,55,0.35))' : 'drop-shadow(0 2px 8px rgba(0,0,0,0.8))', transform: idx === 0 ? 'rotate(-3deg) translateX(4px)' : 'rotate(3deg) translateX(-4px)', marginBottom: '-4px' }} />
                </div>
              ))}
            </div>
          ) : (
            <img loading="lazy" src={getWrestlerRender(champion?.[0]) || placeholder} alt=""
              style={{ height: '320px', objectFit: 'contain', objectPosition: 'top', filter: hasChampion ? 'drop-shadow(0 4px 16px rgba(212,175,55,0.4))' : 'drop-shadow(0 2px 8px rgba(0,0,0,0.8))', marginBottom: '-4px' }} />
          )
        )}
      </div>

      <div style={{ position: 'relative', zIndex: 2, padding: '7px 8px 9px', background: hasChampion && !disabled ? 'rgba(20,10,0,0.95)' : 'rgba(0,0,0,0.75)', borderTop: `1px solid ${hasChampion && !disabled ? 'rgba(212,175,55,0.35)' : 'rgba(212,175,55,0.1)'}`, textAlign: 'center' }}>
        {hasChampion && !disabled ? (
          <>
            <div style={{ fontFamily: "'Anton',sans-serif", fontSize: isTagTeam ? '0.48rem' : '0.58rem', letterSpacing: '1px', color: '#d4af37', marginBottom: '2px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {isTagTeam ? `${getWrestlerNameUpper(champion[0], 'display')} & ${getWrestlerNameUpper(champion[1], 'display')}` : getWrestlerNameUpper(champion[0], 'display')}
            </div>
            <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.42rem', color: 'rgba(212,175,55,0.5)', letterSpacing: '1px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{titleLabel}</div>
          </>
        ) : (
          <>
            <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.42rem', color: disabled ? 'rgba(255,255,255,0.1)' : 'rgba(212,175,55,0.35)', letterSpacing: '1px', marginBottom: '2px' }}>VACANT</div>
            <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '0.58rem', letterSpacing: '1px', color: disabled ? 'rgba(255,255,255,0.1)' : 'rgba(212,175,55,0.5)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{titleLabel}</div>
          </>
        )}
        {!disabled && (
          <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.4rem', color: 'rgba(212,175,55,0.3)', letterSpacing: '1px', marginTop: '3px' }}>
            {hasChampion ? '✏ EDIT' : '+ SET'}
          </div>
        )}
      </div>
    </div>
  );
};

// ── MAIN ────────────────────────────────────────────────────────────
export default function SetChampions({ brand, roster, onBack, onConfirm, customTitleOverrides }) {
  const brandLogo = BRAND_LOGOS[brand];
  const brandBg = BRAND_BGS[brand];
  const baseSlots = DEFAULT_SLOTS[brand] || DEFAULT_SLOTS.default;

  const brandDefaults = BRAND_DEFAULT_TITLES[brand] || {};

  const buildSlots = () => {
    const applyDefault = (arr) => arr.map(s => {
      // Priority: customTitleOverrides (custom brand) > BRAND_DEFAULT_TITLES (official brand)
      const customDef = customTitleOverrides && customTitleOverrides[s.key];
      const def = customDef || brandDefaults[s.key];
      if (customDef) {
        return { ...s, titleOverride: { id: customDef.id, name: customDef.name, render: customDef.render || getTitleRender(customDef.id) } };
      }
      return def ? { ...s, titleOverride: { id: def.id, name: def.name, render: getTitleRender(def.id) } } : { ...s };
    });
    return {
      male: applyDefault(baseSlots.male),
      female: applyDefault(baseSlots.female),
      tagteam: applyDefault(baseSlots.tagteam),
      custom: [],
    };
  };

  const [slots, setSlots] = useState(buildSlots());
  const [champions, setChampions] = useState({});
  const [activePicker, setActivePicker] = useState(null);
  const [customTitles, setCustomTitles] = useState([]);
  const [confirmReset, setConfirmReset] = useState(false);

  const setChampion = (key, value) => setChampions(prev => ({ ...prev, [key]: value }));

  const updateSlotTitle = (key, titleData) => {
    const enriched = titleData ? { ...titleData, render: titleData.render || getTitleRender(titleData.id) } : titleData;
    const update = (arr) => arr.map(s => s.key === key ? { ...s, titleOverride: enriched } : s);
    setSlots(prev => ({
      ...prev,
      male: update(prev.male),
      female: update(prev.female),
      tagteam: update(prev.tagteam),
      custom: update(prev.custom),
    }));
  };

  const handleEditCustomTitle = (t, isEdit) => {
    setCustomTitles(prev => isEdit ? prev.map(ct => ct.id === t.id ? t : ct) : [...prev, t]);
  };

  const handleDeleteCustomTitle = (id) => {
    setCustomTitles(prev => prev.filter(ct => ct.id !== id));
  };

  const handleVacantAll = () => setChampions({});

  const handleReset = () => {
    setSlots(buildSlots());
    setChampions({});
    setCustomTitles([]);
    setConfirmReset(false);
  };

  const allSlots = [...slots.male, ...slots.female, ...slots.tagteam, ...slots.custom];

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 1000 }}>
      <style>{css}</style>
      <img loading="lazy" src={background} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 0 }} />
      {brandBg && <img loading="lazy" src={brandBg} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.15, zIndex: 1 }} />}
      <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at center, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.9) 100%)', zIndex: 2 }} />
      <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at 50% 20%, rgba(212,175,55,0.05) 0%, transparent 55%)', zIndex: 3, pointerEvents: 'none' }} />

      {activePicker && (
        <SlotPicker
          slot={activePicker}
          champion={champions[activePicker.key]}
          customTitles={customTitles}
          roster={roster}
          onClose={() => setActivePicker(null)}
          onSaveChampion={(val) => setChampion(activePicker.key, val)}
          onSaveTitle={(title) => updateSlotTitle(activePicker.key, title)}
          onEditCustomTitle={handleEditCustomTitle}
          onDeleteCustomTitle={handleDeleteCustomTitle}
        />
      )}

      {confirmReset && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 400, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(4px)' }}>
          <div style={{ ...S.panel, maxWidth: '360px', width: '100%', padding: '26px', textAlign: 'center' }}>
            <div style={{ ...S.goldTitle, fontSize: '0.9rem', marginBottom: '10px' }}>RESET ALL?</div>
            <div style={{ ...S.mono, fontSize: '0.52rem', color: 'rgba(255,255,255,0.4)', marginBottom: '20px' }}>Titres custom et champions supprimés.</div>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <button className="btn-wwe" style={S.btn} onClick={() => setConfirmReset(false)}>CANCEL</button>
              <button className="btn-red" style={{ ...S.btn, borderColor: 'rgba(231,76,60,0.5)', color: '#e74c3c' }} onClick={handleReset}>RESET</button>
            </div>
          </div>
        </div>
      )}

      <div style={{ position: 'absolute', inset: 0, zIndex: 10, display: 'flex', flexDirection: 'column', padding: '16px 28px 16px', gap: '14px', overflow: 'hidden' }}>
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexShrink: 0 }}>
          {brandLogo && <img loading="lazy" src={brandLogo} alt={brand} style={{ height: '44px', objectFit: 'contain', filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.9))' }} />}
          <div style={{ ...S.goldTitle, fontSize: '1.4rem' }}>CHAMPIONSHIPS</div>
          <div style={{ display: 'flex', gap: '8px', marginLeft: 'auto' }}>
            <button className="btn-wwe" style={{ ...S.btn, fontSize: '0.5rem' }} onClick={handleVacantAll}>VACANT ALL</button>
            <button className="btn-red" style={{ ...S.btn, borderColor: 'rgba(231,76,60,0.3)', color: 'rgba(231,76,60,0.6)', fontSize: '0.5rem' }} onClick={() => setConfirmReset(true)}>↺ RESET</button>
          </div>
        </div>

        {/* Main panel */}
        <div style={{ ...S.panel, flex: 1, overflow: 'hidden', padding: '18px 22px' }}>
          <div style={{ height: '100%', display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '22px', alignItems: 'center' }}>

            {/* MALE */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', overflow: 'hidden' }}>
              <div style={{ ...S.goldTitle, fontSize: '0.85rem', textAlign: 'center', letterSpacing: '3px', paddingBottom: '8px', borderBottom: '1px solid rgba(212,175,55,0.2)' }}>MALE</div>
              <div style={{ display: 'grid', gridTemplateColumns: `repeat(${Math.max(slots.male.length, 1)}, 1fr)`, gap: '10px' }}>
                {slots.male.map((s, i) => (
                <div key={s.key} style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <div style={{ ...S.mono, fontSize: '0.44rem', color: 'rgba(212,175,55,0.45)', letterSpacing: '1px', textAlign: 'center' }}>{i === 0 ? 'MAJOR' : 'MINOR'}</div>
                  <TitleCard slot={s} champion={champions[s.key]} onClick={() => setActivePicker(s)} />
                </div>
              ))}
              </div>
            </div>

            {/* TAG TEAM */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', overflow: 'hidden' }}>
              <div style={{ ...S.goldTitle, fontSize: '0.85rem', textAlign: 'center', letterSpacing: '3px', paddingBottom: '8px', borderBottom: '1px solid rgba(212,175,55,0.2)' }}>TAG TEAM</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {[{ division: 'MALE DIVISION', key: 'tagteam-male' }, { division: 'FEMALE DIVISION', key: 'tagteam-female' }].map(({ division, key }) => {
                  const s = slots.tagteam.find(t => t.key === key);
                  return (
                    <div key={key} style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                      <div style={{ ...S.mono, fontSize: '0.42rem', color: 'rgba(212,175,55,0.4)', letterSpacing: '1px', textAlign: 'center' }}>{division}</div>
                      {s
                        ? <TitleCard slot={s} champion={champions[s.key]} onClick={() => setActivePicker(s)} />
                        : <TitleCard slot={{ label: 'N/A', isTagTeam: true }} disabled />}
                    </div>
                  );
                })}
              </div>
            </div>

            {/* FEMALE */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', overflow: 'hidden' }}>
              <div style={{ ...S.goldTitle, fontSize: '0.85rem', textAlign: 'center', letterSpacing: '3px', paddingBottom: '8px', borderBottom: '1px solid rgba(212,175,55,0.2)' }}>FEMALE</div>
              <div style={{ display: 'grid', gridTemplateColumns: slots.female.length > 0 ? `repeat(${slots.female.length}, 1fr)` : '1fr 1fr', gap: '10px' }}>
                {slots.female.length > 0
                  ? slots.female.map((s, i) => (
                      <div key={s.key} style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                        <div style={{ ...S.mono, fontSize: '0.44rem', color: 'rgba(212,175,55,0.45)', letterSpacing: '1px', textAlign: 'center' }}>{i === 0 ? 'MAJOR' : 'MINOR'}</div>
                        <TitleCard slot={s} champion={champions[s.key]} onClick={() => setActivePicker(s)} />
                      </div>
                    ))
                  : [1, 2].map(i => <TitleCard key={i} slot={{ label: 'N/A', isTagTeam: false }} disabled />)}
              </div>
            </div>
          </div>
        </div>

        {/* Custom titles */}
        {slots.custom.length > 0 && (
          <div style={{ ...S.panel, padding: '10px 16px', flexShrink: 0 }}>
            <div style={{ ...S.goldTitle, fontSize: '0.6rem', marginBottom: '8px', letterSpacing: '2px' }}>CUSTOM TITLES</div>
            <div style={{ display: 'flex', gap: '10px', overflowX: 'auto' }}>
              {slots.custom.map(s => (
                <div key={s.key} style={{ width: '150px', flexShrink: 0 }}>
                  <TitleCard slot={s} champion={champions[s.key]} onClick={() => setActivePicker(s)} />
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Footer */}
        <div style={{ display: 'flex', justifyContent: 'space-between', flexShrink: 0 }}>
          <button className="btn-wwe" style={{ ...S.btn, color: 'rgba(255,255,255,0.35)', borderColor: 'rgba(255,255,255,0.15)' }} onClick={onBack}>← BACK</button>
          <button className="btn-gold" style={{ ...S.btn, borderColor: 'rgba(212,175,55,0.55)', color: '#d4af37', padding: '10px 40px', fontSize: '0.7rem', letterSpacing: '2px' }}
            onClick={() => onConfirm({ slots: allSlots, champions })}>
            🎬 SEASON DEBUT
          </button>
        </div>
      </div>
    </div>
  );
}
